<template>
  <div>
    <div class="d-flex justify-center">
      <div v-if="consultation.status != 'submitted'" style="position: fixed; bottom: 30px; right: 30px;" id="save-button-handler">
        <v-btn style="box-shadow: -4px 4px 10px #777 !important;" rounded color="primary" depressed :loading="isSaving" @click="form_validation()" class="text-none" id="global-save-button">
          <v-icon>mdi-content-save</v-icon><h2 style="margin-left: 5px;">SAVE</h2>
        </v-btn>
        <VTTButton :mode="'button'"/>
      </div>
    </div>

    <br/><br/>
    <hr />
    <br/><br/><br/><br/>

    <center>
      <h3 class="grey--text text--darken-3 mt-10">Case Summary <small><i>(Make sure to click the <span style="color: red;">Save Case Changes</span> to make it reflect in this section)</i></small></h3>
    </center>

    <v-row justify="center">
      <!-- Summary of summaries -->
      <v-col cols="8">
        <v-card id="summary" color="grey lighten-4">
          
          <v-row justify="center" v-if="pdf_gen_err_message.length > 0">
            <v-col cols="12">
              <v-card-title>
                <h4><span style="color: red;">Error: </span> <i style="word-break: normal !important;">{{ pdf_gen_err_message }}</i></h4>
              </v-card-title>
            </v-col>
          </v-row>
          

          <v-card-title v-show="$vuetify.breakpoint.smAndUp">
            Shared with Patient
            <v-btn v-if="consultation.status != 'submitted'" dark class="ml-auto text-none" @click="generate()" :loading="isGenerating" color="grey darken-2">
              <v-icon left>
                mdi-refresh
              </v-icon>
              Generate PDF
            </v-btn>
          </v-card-title>

          <v-list dense subheader flat>
            


            <!-- Care Plan -->
            <v-list-item dense>
              <v-list-item-action>
                <v-tooltip left>
                  <template v-slot:activator="{ on, attrs }">
                    <div v-bind="attrs" v-on="on">
                      <v-switch v-model="plan" dense></v-switch>
                    </div>
                  </template>
                  <span>Send</span>
                </v-tooltip>
              </v-list-item-action>

              <v-list-item-content>
                <v-list-item-title>Care Plan</v-list-item-title>
              </v-list-item-content>
              
              <v-list-item-action>
                <v-btn @click.stop.prevent @click="openDocument('plan')" :disabled="!file_careplan" color="primary" class="text-none">
                  <v-icon left>mdi-file</v-icon>
                  View PDF
                </v-btn>
              </v-list-item-action>
            </v-list-item>



            <!-- Prescription -->
            <v-list-item dense>
              <v-list-item-action>
                <v-tooltip left>
                  <template v-slot:activator="{ on, attrs }">
                    <div v-bind="attrs" v-on="on">
                      <v-switch v-model="prescription" dense></v-switch>
                    </div>
                  </template>
                  <span>Send</span>
                </v-tooltip>
              </v-list-item-action>

              <v-list-item-content>
                <v-list-item-title>Prescriptions</v-list-item-title>
              </v-list-item-content>
              
              <v-list-item-action>
                <v-btn @click.stop.prevent @click="openDocument('prescription')" :disabled="!file_prescription" color="primary" class="text-none">
                  <v-icon left>mdi-file</v-icon>
                  View PDF
                </v-btn>
              </v-list-item-action>
            </v-list-item>

            

            <!-- Medical Certificate -->
            <v-list-item dense>
              
              <v-list-item-action>
                <v-tooltip left>
                  <template v-slot:activator="{ on, attrs }">
                    <div v-bind="attrs" v-on="on">
                      <v-switch v-model="certificate" dense @change="certificate_rejected = certificate_rejected ? false : false"></v-switch>
                    </div>
                  </template>
                  <span>Send</span>
                </v-tooltip>
              </v-list-item-action>

              <v-list-item-content>
                <v-list-item-title>Medical Certificate</v-list-item-title>
              </v-list-item-content>
              
              <v-list-item-action>
                <v-btn @click.stop.prevent @click="openDocument('certificate')" :disabled="!file_medical_certificate" color="primary" class="text-none">
                  <v-icon left>mdi-file</v-icon>
                  View PDF
                </v-btn>
              </v-list-item-action>
            </v-list-item>
            

            <!-- **************************************** LABORATORY **************************************** -->

            <v-list-item dense>
              <v-list-item-action>
                <v-tooltip left>
                  <template v-slot:activator="{ on, attrs }">
                    <div v-bind="attrs" v-on="on">
                      <v-switch v-model="laboratory" dense></v-switch>
                    </div>
                  </template>
                  <span>Send</span>
                </v-tooltip>
              </v-list-item-action>

              <v-list-item-content>
                <v-list-item-title>Laboratory Request</v-list-item-title>
              </v-list-item-content>
              
              <v-list-item-action>
                <v-btn @click.stop.prevent @click="openDocument('laboratory')" :disabled="!file_laboratory" color="primary" class="text-none">
                  <v-icon left>mdi-file</v-icon>
                  View PDF
                </v-btn>
              </v-list-item-action>
            </v-list-item>

            <!-- **************************************** LABORATORY **************************************** -->

          </v-list>
        </v-card>
      </v-col>
    </v-row>

    <document-frame v-model="document.dialog" :link="document.link"></document-frame>

    
    <!-- **************************************** SUCCESS POPUP **************************************** -->
    
    <v-dialog v-model="saveSuccessDialog" max-width="400px" persistent>
      <v-card class="px-5 py-10" rounded="lg">
        <v-card-text>
          <slot>
            <h2 class="text-center">
              Success! Data is saved in patient and case information.
            </h2>
          </slot>
        </v-card-text>
        <v-card-actions class="d-flex justify-center">
          <!-- Confirm Btn -->
          <v-btn rounded depressed color="primary" width="100px" class="mx-3" @click="saveSuccessDialog = false">
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- **************************************** SUCCESS POPUP **************************************** -->





    <!-- **************************************** ERROR POPUP **************************************** -->
    
    <v-dialog v-model="saveErrorDialog" max-width="400px" persistent>
      <v-card class="px-5 py-10" rounded="lg">
        <v-card-text>
          <slot>
            <h2 class="text-center">
              Failed to save all data. Please try again.
            </h2>
          </slot>
        </v-card-text>
        <v-card-actions class="d-flex justify-center">
          <!-- Confirm Btn -->
          <v-btn rounded depressed color="primary" width="100px" class="mx-3" @click="saveErrorDialog = false;">
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- **************************************** ERROR POPUP **************************************** -->





    <!-- **************************************** ERROR POPUP **************************************** -->
    
    <v-dialog v-model="saveFormErrorDialog" max-width="400px" persistent>
      <v-card class="px-5 py-10" rounded="lg">
        <v-card-text>
          <slot>
            <h2 class="text-center">
              Please make sure that you have filled all the required fields
            </h2>
          </slot>
        </v-card-text>
        <v-card-actions class="d-flex justify-center">
          <!-- Confirm Btn -->
          <v-btn rounded depressed color="primary" width="100px" class="mx-3" @click="saveFormErrorDialog = false;">
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- **************************************** ERROR POPUP **************************************** -->

    <!-- **************************************** ERROR POPUP **************************************** -->
    
    <v-dialog v-model="saveFormNotesErrorDialog" max-width="400px" persistent>
      <v-card class="px-5 py-10" rounded="lg">
        <v-card-text>
          <slot>
            <h2 class="text-center">
              {{ messageFormNoteError }}
            </h2>
          </slot>
        </v-card-text>
        <v-card-actions class="d-flex justify-center">
          <!-- Confirm Btn -->
          <v-btn rounded depressed color="primary" width="100px" class="mx-3" @click="saveFormNotesErrorDialog = false;">
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- **************************************** ERROR POPUP **************************************** -->

  </div>
</template>

<script>

  import VTTButton from '../../../../../components/custom/VTTButton.vue';

  import { GET_TEMPLATES } from '../../../Widgets/typeDefs/MedOpsTemplate';

  export default {
    name: 'FormCaseSummary',

    components: {
      DocumentFrame: () => import('./DocumentFrame.vue'),
      VTTButton
    },

    /* ---------------------------------------------------------------- FUNCTION SEPARATOR ---------------------------------------------------------------- */

    data: ()=>({
      // activeSummary: 0,
      isSaving: false,
      saveSuccessDialog: false,
      saveErrorDialog: false,
      saveFormErrorDialog: false,
      saveFormNotesErrorDialog: false,
      messageFormNoteError: '',
      isGenerating: false,
      templateOptions: {},
      validOptionsTitle: [],
      document: {
        dialog: false,
        link: ''
      },
      pdf_gen_err_message: "",
    }),

    /* ---------------------------------------------------------------- FUNCTION SEPARATOR ---------------------------------------------------------------- */

    computed: {
      patient_emails() {
        var emails = []
        emails = this.$store.getters['patient/email_options'];
        return emails
      },

      destination_email: {
        get() { return this.$store.getters['request/destination_email'] },
        set(val) { this.$store.commit('request/setDestinationEmail', val) }
      },


      isGenerated: {
        get() { return this.$store.getters['request/isGenerated'] },
        set() { this.$store.commit('request/setIsGenerated') }
      },

      consultation() { return this.$store.getters['consultation/activeInfo'] },
      plan: {
        get() { return this.$store.getters['request/plan'] },
        set() { this.$store.commit('request/setPlan') }
      },

      file_careplan: {
        get() { return this.$store.getters['request/file_careplan'] },
        set() { this.$store.commit('request/setFilePlan') }
      },


      
      prescription: {
        get() { return this.$store.getters['request/prescription'] },
        set() { this.$store.commit('request/setPrescription') }
      },

      file_prescription: {
        get() { return this.$store.getters['request/file_prescription'] },
        set() { this.$store.commit('request/setFilePrescription') }
      },




      certificate: {
        get() { return this.$store.getters['request/certificate'] },
        set(val) { this.$store.commit('request/setCertificate', val) }
      },

      file_medical_certificate: {
        get() { return this.$store.getters['request/file_medical_certificate'] },
        set(val) { this.$store.commit('request/setFileMedicalCertificate', val) }
      },

      


      laboratory: {
        get() { return this.$store.getters['request/laboratory'] },
        set(val) { this.$store.commit('request/setLaboratory', val) }
      },

      file_laboratory: {
        get() { return this.$store.getters['request/file_laboratory'] },
        set(val) { this.$store.commit('request/setFileLaboratory', val) }
      },



      certificate_rejected: {
        get() { return this.$store.getters['request/certificate_rejected'] },
        set(val) { this.$store.commit('request/setCertificateRejected', val) }
      },
      
    },

    mounted() {
        this.templateOptions = GET_TEMPLATES;
        for (let ii in this.templateOptions) {
            this.validOptionsTitle.push(this.templateOptions[ii].notes.title);
        }
    },

    /* ---------------------------------------------------------------- FUNCTION SEPARATOR ---------------------------------------------------------------- */

    methods: {
      async generate() {
        if(
          !this.plan &&
          !this.prescription &&
          !this.certificate &&
          !this.certificate_rejected &&
          !this.laboratory
        ) {
          this.pdf_gen_err_message = "You didnt select any document to generate.";
          return false;
        }

        var case_info = this.$store.getters['cases/activeInfo'];
        var caseId = this.$store.getters['cases/activeInfo'].id;
        var consultId = this.consultation.id;
        let compiled_medications = await this.$store.dispatch('medication/compiled_medications', {case_id: caseId, consult_id: consultId});
        let diagnoses_data = await this.$store.dispatch('diagnosis/compiled_diagnoses', {case_id: caseId, consult_id: consultId});
        let compiled_recommendations = await this.$store.dispatch('recommendation/compiled_recommendations', {case_id: caseId, consult_id: consultId});
        let laboratory_list = this.$store.getters['request/tests'];

        let medicalCertificate = this.$store.getters['request/certificate'];
        let medicalCertificateRemarks = this.$store.getters['request/certificate_remark'];
        case_info.medicines = compiled_medications;

        /* ###################################### FORM  VALIDATION WITH ERROR MESSAGES ###################################### */

        console.log("[laboratory_list]", laboratory_list);

        if(this.laboratory) {
          if(laboratory_list) {
            if((laboratory_list.length == 0 || diagnoses_data.length == 0)) {
              this.pdf_gen_err_message = "You cant generate a laboratory request without a selected test to perform or a diagnosis";
              return false;
            }
          }
        }

        if(this.plan && diagnoses_data.length == 0) {
          this.pdf_gen_err_message = "You cant generate a CMT without a diagnosis";
          return false;
        }

        if(this.plan && (diagnoses_data.length == 0 || compiled_recommendations.length == 0)) {
          this.pdf_gen_err_message = "You cant generate a CMT without a diagnosis or recommendation";
          return false;
        }

        if(this.certificate && diagnoses_data.length == 0) {
          this.pdf_gen_err_message = "You cant generate a MedCert without a diagnosis";
          return false;
        }

        if(this.certificate) {
          if(!medicalCertificate || !medicalCertificateRemarks) {
            this.pdf_gen_err_message = "You cant generate a Medcert if Number of Days or Remarks is empty";
            return false;   
          }
        }

        let current_medication_count = 0;
        compiled_medications.forEach(medication_instance => {
          if(medication_instance.record_type == "current") {
            current_medication_count++;
          }
        });

        if(current_medication_count == 0 && this.prescription) {
          this.pdf_gen_err_message = "You need to have at least one current medication to generate Prescription documents";
          return false;
        }

        /* ###################################### FORM  VALIDATION WITH ERROR MESSAGES ###################################### */

        this.pdf_gen_err_message = "";

        

        // const allowGeneratePDF = medicalCertificate && medicalCertificateRemarks ? true : false
        let allowGeneratePDF = false
        if (!medicalCertificate) {
          allowGeneratePDF = true
        } else {
          allowGeneratePDF = Boolean(medicalCertificate) == Boolean(medicalCertificateRemarks)
        }

        console.log({
          medicalCertificate,
          medicalCertificateRemarks,
          allowGeneratePDF,
          boolean: [
            Boolean(medicalCertificate),
            Boolean(medicalCertificateRemarks)
          ]
        })

        this.$emit('click:generate-pdf', allowGeneratePDF);

        if (allowGeneratePDF) {
          this.isGenerating = true;



          let response = await this.$store.dispatch('request/generate', { id: this.consultation.id, sendPdf: false, generatePdf: true, request_data: this.consultation.requests, case_info : case_info })
          
          if (response.status == 200) {            
            
            /*this.file_careplan = response.data.file_careplan
            this.file_prescription = response.data.file_prescription
            this.file_medical_certificate = response.data.file_medical_certificate
            this.file_laboratory = response.data.file_laboratory*/
            this.$store.commit('request/setIsGenerated', true);
            this.isGenerating = false;

            console.log("[sync back to consultations]", response.data);
            this.$store.commit('consultation/setLatestConsultationRequest', response.data);
          }
        } 
      },

      /* #################################### API CALL SEPARATOR #################################### */

      openDocument(file) {
        switch (file) {
          case 'plan':
            this.document.link = this.file_careplan
            this.document.dialog = true
            break;
          case 'prescription':
            this.document.link = this.file_prescription
            this.document.dialog = true
            break;
          case 'certificate':
            this.document.link = this.file_medical_certificate
            this.document.dialog = true
            break;
          case 'laboratory':
            this.document.link = this.file_laboratory
            this.document.dialog = true
            break;
          default:
            break;
        }
      },

      validateNotes (note) {

        if ( this.validOptionsTitle.indexOf(note.title) < 0 ) {
          return true;
        }

        let message = note.note.replaceAll(' ', '').toLowerCase().replace(/\n|\r|-/g, '');
        if (message.indexOf('enterdatahere') > -1) {
          this.saveFormNotesErrorDialog = true;
          this.messageFormNoteError = 'Please update the Notes with the correct details';
          return false;
        } else if (message.match(/[^/0-9A-Za-zñÑ:\n'+/.(),&?-|*!%<>]/) != null) {
          this.saveFormNotesErrorDialog = true;
          this.messageFormNoteError = 'Please remove brackets in the notes area';
          return false;
        } 
        // else {
          // let hasEmptyVal = false;
          // let noteParts = note.note.split("\n").filter(n => n);
          // noteParts.map(function(val) {
          //   let checked = val.split(":").map(function(val2) { if (val2.replaceAll(' ', '') != '') {return val2.trim()} }).filter(n => n);
          //   if (checked.length <= 1) {
          //     hasEmptyVal = true;
          //   }
          // });

          // if (hasEmptyVal) {
          //   this.saveFormNotesErrorDialog = true;
          //   this.messageFormNoteError = 'Please check notes entered values';
          //   return false;
          // }
        // }
        return true;
      },

      /* #################################### API CALL SEPARATOR #################################### */


      form_validation() {
        if(!this.destination_email) {
          this.destination_email = this.patient_emails[0];
        }

        var vices = this.$store.getters['patient/vices'];
        var dietary = this.$store.getters['patient/dietary'];
        var immunization = this.$store.getters['patient/immunization'];
        var illnesses = this.$store.getters['patient/illnesses'];
        var operations = this.$store.getters['patient/operations'];
        var hospitalizations = this.$store.getters['patient/hospitalizations'];
        var notes = this.$store.getters['cases/notes'];

        if (notes.length > 0) {
          for (let ni in notes) {
            if (!this.validateNotes(notes[ni])) {
              return false;
            }
          }
        }

        this.$store.commit('patient/clearErrorMessages');
        var default_empty_alert = "This field cant be empty";

        if(!vices || vices == '') { this.$store.commit('patient/update_vices_alert_message', default_empty_alert); }
        if(!dietary || dietary == '') { this.$store.commit('patient/update_dietary_alert_message', default_empty_alert); }
        if(!immunization || immunization == '') { this.$store.commit('patient/update_immunization_alert_message', default_empty_alert); }
        if(!illnesses || illnesses == '') {this.$store.commit('patient/update_illnesses_alert_message', default_empty_alert); }
        if(!operations || operations == '') {this.$store.commit('patient/update_operations_alert_message', default_empty_alert); }
        if(!hospitalizations || hospitalizations == '') { this.$store.commit('patient/update_hospitalizations_alert_message', default_empty_alert); }

        if(
          (!vices || vices == '') ||
          (!dietary || dietary == '') ||
          (!immunization || immunization == '') ||
          (!illnesses || illnesses == '') ||
          (!operations || operations == '') ||
          (!hospitalizations || hospitalizations == '')
        ) {
          this.saveFormErrorDialog = true;
          return false;
        } else {
          this.save();
        }
      },


      /* #################################### API CALL SEPARATOR #################################### */

      async save() {
        // let that = this;
        var current_case = this.$store.getters['cases/case'];
        var caseInfo = this.$store.getters['cases/activeInfo'];
        var caseId = this.$store.getters['cases/activeInfo'].id;
        var consultId = this.consultation.id;
        var patientId = caseInfo.patient.patient.id;
        var userId = caseInfo.patient.id;

        console.log("saving caseInfo", current_case);

        console.log('[case-consult-user-patient-id]', {caseId, consultId, userId, patientId})

        try {
          this.isSaving = true

          /* ***************************************************** RETRIEVAL OF ALL VALUES RELATED TO THE CASE ***************************************************** */

          let full_payload = {};
          let examination_data = await this.$store.dispatch('examination/compiled_examination', {case_id: caseId, user_id: userId});
          let diagnoses_data = await this.$store.dispatch('diagnosis/compiled_diagnoses', {case_id: caseId, consult_id: consultId});
          let compiled_recommendations = await this.$store.dispatch('recommendation/compiled_recommendations', {case_id: caseId, consult_id: consultId});
          let compiled_medications = await this.$store.dispatch('medication/compiled_medications', {case_id: caseId, consult_id: consultId});
          let compiled_patient_info = await this.$store.dispatch('patient/compiled_patient_info', userId);

          /* ***************************************************** RETRIEVAL OF ALL VALUES RELATED TO THE CASE ***************************************************** */          



          /* ######################## ASSOCIATIVE VALUES OF CASES ######################## */

          full_payload.examination_data = examination_data;
          full_payload.diagnoses_data = diagnoses_data;
          full_payload.recommendations_data = compiled_recommendations;
          full_payload.medications_data = compiled_medications;
          full_payload.compiled_patient_info = compiled_patient_info;
          full_payload.consultation_id = this.consultation.id;
          full_payload.terminator = caseInfo.consultations[0].terminator;

          /* ######################## ASSOCIATIVE VALUES OF CASES ######################## */

          console.log("[full payload]");
          console.log(full_payload);
          let saved_case = await this.$store.dispatch('cases/save', {caseId, full_payload});
          console.log("[saved case]");
          console.log(saved_case);

          saved_case.data.image_ignore = true;

          /* &&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&& RELOADING SAVED/UPDATED DATA WITH ID IN IT &&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&& */

          this.$store.commit('diagnosis/loadSavedData', saved_case.data.diagnoses);
          this.$store.commit('examination/loadSavedData', saved_case.data.examinations);
          this.$store.commit('recommendation/loadSavedData', saved_case.data.recommendations);
          this.$store.commit('medication/loadSavedData', saved_case.data.medicines);
          this.$store.commit('diagnosis/loadSavedData', saved_case.data.diagnoses);
          this.$store.commit('cases/setActiveInfo', saved_case.data);

          /* &&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&& RELOADING SAVED/UPDATED DATA WITH ID IN IT &&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&& */

          // return false;

          // create and send request
          // let request_creation = this.$store.dispatch('request/create', { id: consultId, sendPdf: false, generatePdf: false, request_data: this.consultation.requests }); //08-02
          
          // if(!this.laboratory) {
          //   console.log("laboratory doesnt exist yet");
          //   request_creation.then( function (result) {
          //     console.log("[request creation]", result);
          //     let toSyncRequestData = [];
          //     toSyncRequestData.push(result.data);
          //     that.$store.commit('request/loadSavedData', toSyncRequestData);
          //   });
          // }

          this.isSaving = false
          this.saveSuccessDialog = true;
          this.$store.commit('request/setIsGenerated', false);

        } catch(e) {
          
          this.isSaving = false
          this.saveErrorDialog = true
          console.log('[error]', e)

        }
      },
    }
  }
</script>

<style lang="scss" scoped>
  #summary {
    position:-webkit-sticky;
    position: sticky;
    top: 5px;
  }

  .pdfSendContainer {
    position:relative;
    bottom:80px;
    height:80px;
    background-color: rgba(150,150,150,0.7);
    z-index: 9999;
    opacity: 0.5  ;
  }

  .pdfSendContainer:hover {
    opacity: 1;
  }
</style>